// Function to read the current number of the counter
export function readCounter() {
  // Check if the counter already exists in local storage
  if (localStorage.getItem('counter')) {
    // Get the counter value from local storage
    var counterData = JSON.parse(localStorage.getItem('counter')!);

    // Check if it's the same day
    var storedDate = new Date(counterData.date);
    var currentDate = new Date();
    if (storedDate.getDate() === currentDate.getDate() &&
        storedDate.getMonth() === currentDate.getMonth() &&
        storedDate.getFullYear() === currentDate.getFullYear()) {
      // If it's the same day, return the current value of the counter
      return counterData.value;
    }
  }

  // If it doesn't exist or it's a new day, return 0
  return 0;
}

// Function to increment the counter by one
export function incrementCounter() {
  // Get the current number of the counter by calling the readCounter() function
  var currentCounter = readCounter();

  // Increment the counter by one
  var newCounter = currentCounter + 1;

  // Get the current date and save it along with the counter value
  var currentDate = new Date();
  var counterData = {
    date: currentDate,
    value: newCounter
  };

  // Store the counterData object in local storage
  localStorage.setItem('counter', JSON.stringify(counterData));
}

// Example usage: read the current counter and increment it by one
// console.log('Current counter:', readCounter());
// incrementCounter();
// console.log('New counter:', readCounter());

